'use strict';

module.exports = {
	selectArrows: require('./selectArrows')
};


//////////////////
// WEBPACK FOOTER
// ../~/elemental/lib/icons/index.js
// module id = 574
// module chunks = 0